module.exports = __webpack_public_path__ + "img/img-27.a251953e.png";